// extracted by mini-css-extract-plugin
export default {"groupLabel":"editableLabel_groupLabel__HzHnQ","group-name-editable-input":"editableLabel_group-name-editable-input__P6zVB"};